// extracted by mini-css-extract-plugin
export var divider = "_rx-0";
export var systemMessage = "_rx-1";
export var systemMessageWrapper = "_rx-2";